module.exports = __webpack_public_path__ + "static/media/wirebasket-v2.b94c87fc.png";